import { Dashboard } from "../../../../dashboards/components/Dashboard"
import { AdminHomeCard, AdminHomeCardGroup, AdminHomeCardGroups } from "../../../../admin/components/AdminHomeCard"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import {
    SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_CREATE_ROUTE,
    SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_CREATE_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_MANAGE_BOOKINGS_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE,
    SERVICE_CENTER_MESSAGES_ROUTE,
    SERVICE_CENTER_MESSAGES_CREATE_ROUTE,
    SERVICE_CENTER_REMINDERS_ROUTE,
    SERVICE_CENTER_REPORTS_STATISTICS_ROUTE,
} from "../../../../../constants/routes"
import { useNavigate } from "react-router-dom"
import { MatchEnvironment } from "../../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../../environment/envTypes"

type Props = Readonly<{}>

export function ServiceCenterAdminHome({}: Props) {
    const navigate = useNavigate()

    return (
        <Dashboard>
            <AdminHomeCardGroups>
                <LocalizedStrict id="service-center-admin-nav-item-communication-page-header" attrs={{ title: true }}>
                    <AdminHomeCardGroup title="Communication">
                        <LocalizedStrict
                            id="service-center-admin-home-communication-messages-card"
                            attrs={{ title: true, description: true }}
                        >
                            <AdminHomeCard
                                title="Push messages"
                                description="Send and manage push messages."
                                onShowAllClick={() => navigate(SERVICE_CENTER_MESSAGES_ROUTE)}
                                onCreateClick={() => navigate(SERVICE_CENTER_MESSAGES_CREATE_ROUTE)}
                            />
                        </LocalizedStrict>
                        <MatchEnvironment
                            environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}
                        >
                            <LocalizedStrict
                                id="service-center-admin-home-communication-reminders-card"
                                attrs={{ title: true, description: true }}
                            >
                                <AdminHomeCard
                                    title="Reminders"
                                    description="Manage reminders shared across resources."
                                    onShowAllClick={() => navigate(SERVICE_CENTER_REMINDERS_ROUTE)}
                                    onCreateClick={() => navigate(`${SERVICE_CENTER_REMINDERS_ROUTE}?create=true`)}
                                />
                            </LocalizedStrict>
                        </MatchEnvironment>
                    </AdminHomeCardGroup>
                </LocalizedStrict>
                <MatchEnvironment environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}>
                    <LocalizedStrict
                        id="service-center-admin-nav-item-organization-page-header"
                        attrs={{ title: true }}
                    >
                        <AdminHomeCardGroup title="Organization">
                            <LocalizedStrict
                                id="service-center-admin-home-organization-resources-card"
                                attrs={{ title: true, description: true }}
                            >
                                <AdminHomeCard
                                    title="Resources"
                                    description="Create and manage the resources that can be booked in your service center."
                                    onShowAllClick={() => navigate(SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE)}
                                />
                            </LocalizedStrict>
                            <LocalizedStrict
                                id="service-center-admin-home-organization-devices-card"
                                attrs={{ title: true, description: true }}
                            >
                                <AdminHomeCard
                                    title="Devices"
                                    description="Manage your hardware devices such as room displays and info screens."
                                    onShowAllClick={() => navigate(SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE)}
                                    onCreateClick={() =>
                                        navigate(SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_CREATE_ROUTE)
                                    }
                                />
                            </LocalizedStrict>
                            <LocalizedStrict
                                id="service-center-admin-home-organization-manage-bookings-card"
                                attrs={{ title: true, description: true, buttonText: true }}
                            >
                                <AdminHomeCard
                                    title="Manage user orders"
                                    description="Manage orders owned by a user."
                                    buttonText="Manage"
                                    onShowAllClick={() =>
                                        navigate(SERVICE_CENTER_ADMIN_ORGANIZATION_MANAGE_BOOKINGS_ROUTE)
                                    }
                                />
                            </LocalizedStrict>
                        </AdminHomeCardGroup>
                    </LocalizedStrict>
                </MatchEnvironment>
                <MatchEnvironment environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}>
                    <LocalizedStrict id="service-center-admin-nav-item-reports-page-header" attrs={{ title: true }}>
                        <AdminHomeCardGroup title="Reports">
                            <LocalizedStrict
                                id="service-center-admin-home-reports-statistics-card"
                                attrs={{ title: true, description: true }}
                            >
                                <AdminHomeCard
                                    title="Statistics"
                                    description="See usage, occupancy and guest statistics for your service center."
                                    onShowAllClick={() => navigate(SERVICE_CENTER_REPORTS_STATISTICS_ROUTE)}
                                />
                            </LocalizedStrict>
                        </AdminHomeCardGroup>
                    </LocalizedStrict>
                </MatchEnvironment>
                <LocalizedStrict id="service-center-admin-nav-item-account-page-header" attrs={{ title: true }}>
                    <AdminHomeCardGroup title="Account">
                        <LocalizedStrict
                            id="service-center-admin-home-account-administrators-card"
                            attrs={{ title: true, description: true }}
                        >
                            <AdminHomeCard
                                title="Administrators"
                                description="Manage the administrators for your merchant."
                                onShowAllClick={() => navigate(SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_ROUTE)}
                                onCreateClick={() => navigate(SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_CREATE_ROUTE)}
                            />
                        </LocalizedStrict>
                    </AdminHomeCardGroup>
                </LocalizedStrict>
            </AdminHomeCardGroups>
        </Dashboard>
    )
}
